'use strict';

var App = require('app');
var AppState = require('app_state');

var User = Backbone.Model.extend({
    urlRoot: '/api/v1/me',
    defaults: {
        modelType: 'user',
    },

    isDemoUser: function () {
        return _.indexOf(App.demoUsers, this.id) != -1;
    },

    getPreferences: function () {
        var userConfig = this.get('config') || {};
        return userConfig.info ? userConfig.info.preferences : undefined;
    },
});

var API = {
    getUser: function () {
        var user = new User();
        var defer = $.Deferred();

        user.fetch({
            success: function (data) {
                if (data.attributes.features.dashboard) {
                    data.attributes.features.dashboard = JSON.parse(data.attributes.features.dashboard);
                }
                AppState.requireColumns(function () {
                    defer.resolve(data);
                });
            },
            error: function (data) {
                defer.resolve(undefined);
            },
        });

        return defer.promise();
    },

    getPhoneCode: function (phone) {
        var defer = $.Deferred();
        App.ajax({
            method: 'POST',
            url: '/api/v1/me/phone/getcode',
            data: { phone: phone },
            success: function (data) {
                defer.resolve(undefined);
            },
            error: function (data) {
                defer.resolve(((data && data.responseText) || '').trim() || 'invalid_request');
            },
        });

        return defer.promise();
    },

    savePhoneNumber: function (phone, code) {
        var defer = $.Deferred();
        App.ajax({
            method: 'POST',
            url: '/api/v1/me/phone/save',
            data: { phone: phone, code: code, fingerprint: App.browserFingerprint },
            success: function (data) {
                defer.resolve(undefined);
            },
            error: function (data) {
                defer.resolve(((data && data.responseText) || '').trim() || 'phone_not_saved');
            },
        });

        return defer.promise();
    },

    deletePhoneNumber: function () {
        var defer = $.Deferred();
        App.ajax({
            method: 'DELETE',
            url: '/api/v1/me/phone/delete',
            success: function (data) {
                defer.resolve();
            },
            error: function (data) {
                defer.reject();
            },
        });

        return defer.promise();
    },

    activateMFA: function (code) {
        var defer = $.Deferred();
        App.ajax({
            method: 'POST',
            url: '/api/v1/account/mfa',
            data: { code: code, fingerprint: App.browserFingerprint },
            success: function (data) {
                defer.resolve(undefined);
            },
            error: function (data) {
                defer.resolve(((data && data.responseJSON) || '').trim() || 'mfa_not_activated');
            },
        });

        return defer.promise();
    },

    deactivateMFA: function () {
        var defer = $.Deferred();
        App.ajax({
            method: 'DELETE',
            url: '/api/v1/account/mfa',
            data: {},
            success: function (data) {
                defer.resolve(undefined);
            },
            error: function (data) {
                defer.resolve(((data && data.responseJSON) || '').trim() || 'mfa_not_deactivated');
            },
        });

        return defer.promise();
    },
};

App.reqres.setHandler('user:me', function () {
    return API.getUser();
});

App.reqres.setHandler('user:phone:getcode', function (phone) {
    return API.getPhoneCode(phone);
});

App.reqres.setHandler('user:phone:save', function (phone, code) {
    return API.savePhoneNumber(phone, code);
});

App.reqres.setHandler('user:mfa:activate', function (code) {
    return API.activateMFA(code);
});

App.reqres.setHandler('user:mfa:deactivate', function () {
    return API.deactivateMFA();
});

App.reqres.setHandler('user:phone:delete', function () {
    return API.deletePhoneNumber();
});

module.exports = User;
